"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jsx2 = _interopRequireDefault(require("@babel/runtime/helpers/jsx"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _has2 = _interopRequireDefault(require("lodash/has"));

var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _mapValues2 = _interopRequireDefault(require("lodash/mapValues"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _analyticsContext = _interopRequireDefault(require("./analyticsContext"));

var _jsEvents = _interopRequireDefault(require("../maps/jsEvents"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var matchesId = function matchesId(id, pattern) {
  return id === pattern || pattern.endsWith('*') && id.startsWith(pattern.slice(0, pattern.length - 1));
};

var Tracker = function Tracker(_ref) {
  var children = _ref.children,
      context = _ref.context,
      formFieldValues = _ref.formFieldValues;
  var extendedState = formFieldValues ? {
    form: (0, _defineProperty2.default)({}, formFieldValues.for, formFieldValues)
  } : {};

  switch (true) {
    case !children:
      throw new Error('Error creating Track element:  children is undefined, null, or falsey');

    case ! /*#__PURE__*/(0, _react.isValidElement)(children):
      throw new Error('Error creating Track element:  children of Track element is not a valid React element');

    case !children.props.id:
      throw new Error("'Error creating Track element:  children of Track element has no ID: ".concat(children.type));

    default:
      break;
  }

  var handlers = {};

  if (context && (0, _get2.default)(context, 'analyticsRules.elements')) {
    Object.keys(context.analyticsRules.elements).map(function (id) {
      if (matchesId(children.props.id, id)) {
        (0, _mapValues2.default)(context.analyticsRules.elements[id], function (analyticsValues, event) {
          // add handler with the event name from the analytics rule converted to the proper React event name
          // and assign the track function to it (will call AnalyticsEnhancedComponent.track with proper args)
          handlers[_jsEvents.default[event]] = function (e) {
            var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
            return context.analyticsTrack(e, analyticsValues, callback, extendedState);
          };
        });
      }
    });
  } // compose with existing handlers:


  var composedHandlers = (0, _isEmpty2.default)(handlers) ? null : (0, _mapValues2.default)(handlers, function (handler, event) {
    return function (e) {
      var elementEvent = children.props[event];
      /*
      if the segment script is blocked by an ad blocker, window.analytics.initialized will not exist or if the user has a browser that says do not track do not bother hijacking the click
      This is done at the handler level to allow for the segment js script to load since its async, by the time this handler is being called the user would have to have been on the page long enough
      to click the element which should be enough time for the segment script to be load
      */

      var optedInToTracking = (0, _get2.default)(window, 'analytics.initialized', false) && (0, _get2.default)(navigator, 'doNotTrack') !== '1' && (0, _get2.default)(window, 'doNotTrack') !== '1';

      if ((0, _isFunction2.default)(elementEvent)) {
        elementEvent(e);
      }

      if (!optedInToTracking) {
        return;
      } else {
        // Prevent default click behavior for navigation elements so that we don't navigate
        // away before events are tracked
        var isClickedNavigationElem = (0, _has2.default)(children, 'props.href') && event === 'onClick';

        if (isClickedNavigationElem && typeof e !== 'undefined') {
          e.stopPropagation(); // Allow default behavior in these cases, as the link will be opened in a new tab

          if (e.metaKey || e.ctrlKey) {
            isClickedNavigationElem = false;
          } else {
            e.preventDefault();
          }
        }

        handler(e, function () {
          // For navigation elements, provide navigation behavior in a post-track callback
          if (typeof window !== 'undefined' && isClickedNavigationElem) {
            if ((0, _get2.default)(children.props, 'target')) {
              window.open(children.props.href, (0, _get2.default)(children.props, 'target'));
            } else {
              window.location.href = children.props.href;
            }
          }
        });
      }
    };
  });
  return /*#__PURE__*/(0, _react.cloneElement)(children, composedHandlers);
};

Tracker.displayName = 'Track';
Tracker.contextTypes = {
  analyticsRules: _propTypes.default.object,
  analyticsTrack: _propTypes.default.func,
  formFieldValues: _propTypes.default.any
};

var Track = function Track(_ref2) {
  var children = _ref2.children,
      formFieldValues = _ref2.formFieldValues;
  return /*#__PURE__*/(0, _jsx2.default)(_analyticsContext.default.Consumer, {}, void 0, function (analyticsContext) {
    return /*#__PURE__*/(0, _jsx2.default)(Tracker, {
      children: children,
      context: analyticsContext,
      formFieldValues: formFieldValues
    });
  });
};
/* formFieldValues injected optionally to allow for
  analytics config values like [[form.fieldName.values.value]]
*/


var _default = Track;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/analytics/Track.js
// module id = 3138
// module chunks = 25